module.exports = __webpack_public_path__ + "prod/1.42.2/img/hua-icon.2b265cdf.png";